import React from 'react';
import {
  Flex,
  Heading,
  Loader,
  Squish,
  Stack,
} from '@grubhubprod/gh-cookbook-react';
import { Modal } from 'src/components/Modal/Modal';

export const CreatingChildAccountsModal: React.FC = () => {
  return (
    <Modal size="xs">
      <Squish inset="md">
        <Stack y="sm">
          <Heading variant="h1">Creating child account(s)...</Heading>
        </Stack>
        <Stack y="sm">This might take a few moments.</Stack>
        <Stack y="sm">
          <Flex justifyContent="center">
            <Loader size="md" />
          </Flex>
        </Stack>
      </Squish>
    </Modal>
  );
};
